module.exports = __webpack_public_path__ + "static/media/logo-youtube.385ef505.svg";